<template>
    <div class="c-app flex-row align-items-center">
      <CContainer style="display: flex; justify-content: center" class="p-0">
        <div class="container-box center">
          <div class="text-left">
            <div class="card-custom-web">
              <br />
              
              <div style="margin: 0px 20px;">
                <label class="date-timetable text-black">
                  Please click yes if are present for this class. You will get the class link once you confirm your attandance.
                </label>
              
                <div v-for="item in schedule" v-bind:key="item.Id">
                  <div v-if="item.id == scheId">
                    <div v-for="stud in item.student" v-bind:key="stud.id">

                      <!-- condition kalau isAttend dlm schedule == true  -->
                      <div v-if="stud.isAttend === true">
                        <CCard style="margin-bottom: 10px;">
                          <div class="mt-2 ml-2 mb-2">                   
                            <CRow>
                              <CCol>
                                <label class="text-primary-custom ml-2 mb-0" style="color: #000A2C;">{{stud.studentName}}</label>    
                              </CCol>
                              <CCol>
                                <CRow class="float-right mr-4 mt-3">
                                  <img style="height:23px" src="../../assets/img/icon/iconUndo.png" @click="clickRollback(stud.studentId, item.id)"/>
                                  <img src="../../assets/img/icon/check-circle.svg" class="ml-2"/>
                                </CRow>
                              </CCol>
                            </CRow>
                          </div>
                        </CCard>
                      </div>

                      <div v-else-if="stud.isAttend === false">
                        <div v-if="stud.attend === 2">
                          <CCard style="margin-bottom: 10px;">
                            <div class="mt-2 ml-2 mb-2">                   
                              <CRow>
                                <CCol>
                                  <label class="text-primary-custom ml-2 mb-0" style="color: #000A2C;">{{stud.studentName}}</label>    
                                </CCol>
                                <CCol>
                                  <CRow class="float-right mr-4 mt-3">
                                    <img style="height:23px" src="../../assets/img/icon/iconUndo.png" @click="clickRollback(stud.studentId, item.id)"/>
                                    <img src="../../assets/img/icon/x-circle.svg" class="ml-2"/>
                                  </CRow>
                                </CCol>
                              </CRow>
                            </div>
                          </CCard>
                        </div>

                        <div v-else-if="stud.attend === 0">
                          <CCard style="margin-bottom: 10px;">
                            <div class="mt-2 ml-2 mb-2">                   
                              <CRow>
                                <CCol>
                                  <label class="text-primary-custom ml-2 mb-0" style="color: #000A2C;"> {{ stud.studentName }} </label> 
                                </CCol>
                                <CCol>
                                  <CRow class="float-right mr-4 mt-3">
                                    <label class="text-primary-custom" @click="clickNo(stud.studentId, item.id)">No</label> &nbsp;
                                    <label class="text-primary-custom ml-3" @click="clickYes(stud.studentId, item.id)">Yes</label>
                                  </CRow>
                                </CCol>
                              </CRow>
                            </div>
                          </CCard>
                        </div>

                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div> 

          </div>  

             <!-- popup click class -->
            <CModal style="position: relative;
              width: 375px;
              height: 454px;
              border-radius: 32px;" size="" :show.sync="DetailClass">
              <div v-for="item in schedule" v-bind:key="item.Id">
                <div v-if="item.scheduleId == scheId">
                  <div v-for="stud in item.student" v-bind:key="stud.id">
                    <h6 class="text-center">
                      <strong>{{ item.subjectName }} for {{stud.studentName}}</strong>
                    </h6>
                    <br />
                    <CCard class="p-3">
                      <label>Class Details</label>
                      <img style="width: 50px; height: 50px; object-fit: cover" src="../../assets/img/icon/userprofile2.svg" />
                      <br />
                      <CRow>
                        <CCol sm="3">Tutor</CCol>
                        <CCol sm="9">: {{ item.teacher }} </CCol>

                        <CCol sm="3">Grade</CCol>
                        <CCol sm="9">: {{ item.grade }} </CCol>

                        <CCol sm="3">Subject</CCol>
                        <CCol sm="9">: {{ item.subjectName }} </CCol>

                        <CCol sm="3">Date</CCol>
                        <CCol sm="9">: {{ item.start | moment("DD MMM YYYY - dddd") }} </CCol>

                        <CCol sm="3">Time</CCol>
                        <CCol sm="9">: {{ item.start | moment("hh:mm A") }} - {{ item.end | moment("hh:mm A") }} </CCol>

                        <CCol sm="3">Class Link</CCol>
                        <CCol sm="9" style="color: #007CEF;">: {{ item.joinLink }} </CCol>
                      </CRow>
                    </CCard>

                    <CRow class="justify-content-center mb-2">
                      <CCol style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      ">
                        <CCol sm="12" lg="12">
                          <CCol
                            sm="12"
                            lg="12"
                            style="
                              display: flex;
                              align-items: center;
                              justify-content: center;
                              left: 0;
                              right: 0;
                              bottom: 0px;
                            ">
                            <CCol sm="4" lg="4" class="p-0 mr-2" style="width: 25%">
                              <CCard style="border: none" class="text-center p-1">
                                <CCol>
                                  <img src="../../assets/img/icon/classTutor.svg" @click="GoToTutorProfile(item.id , item.userTeacherId)" />
                                  <br />
                                  <label class="text-icon custom-font-card">Tutor</label>
                                </CCol>
                              </CCard>
                            </CCol>

                            <CCol sm="4" lg="4" class="p-0 mr-2" style="width: 25%">
                              <CCard style="border: none" class="text-center p-1">
                                <CCol>
                                  <img src="../../assets/img/icon/classAttendance.svg" @click="GoToAttendance(item.teacherId , item.id)" />
                                  <br />
                                  <label class="text-icon custom-font-card"> Attendance</label>
                                </CCol>
                              </CCard>
                            </CCol>

                            <CCol sm="4" lg="4" class="p-0 mr-2" style="width: 25%">
                              <CCard style="border: none" class="text-center p-1">
                                <CCol>
                                  <img src="../../assets/img/icon/classChat.svg" style="-webkit-filter: grayscale(1); filter: grayscale(1);" />
                                  <br />
                                  <label class="text-icon custom-font-card">Chat</label>
                                </CCol>
                              </CCard>
                            </CCol>
                          </CCol>
                        </CCol>
                      </CCol>
                    </CRow>
                </div>
              </div>
              </div>
              <div style="clear:both"></div>
            </CModal>

            <!-- </div> -->
        
        </div>
      </CContainer>
  
      
      <div class="header-top">Attendance</div>
      <div class="header-left">
        <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()" />
      </div>
      <div style="clear: both"></div>
    </div>
  </template>
  
  <script>
  export default {
    data: function () {
      return {
        attendance: true,
        attendanceYes: false,
        attendanceNo: false,
        DetailClass: false,
        // childs: [],
        user: {},
        schedulebyid: {},
        // schedule:[],
        // attendance: [],
        schedule: [],
        // testing: "",
        scheId: this.$route.query.scheduleId,
        studID: "",
        
        // studentSelected: "",
      }
    },
  
    async mounted() {
      let isAuth = await this.UserAuth();
  
      if (isAuth) {
        this.Busy = false;
        this.GetInfoUser();
      } else {
        this.GoToLogin();
      }
    },
  
    methods: {      
      GetInfoUser() {
        return this.$API
          .get(this.$LoginUserDetailWebs, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200) {
              this.user = response.data;
              // this.GetScheduleByScheduleId(this.user.id);
              this.GetTutorScheduleToday(this.user.id);
              this.CheckAttendanceToday(this.user.id)
            }
          });
      },
  
      // GetScheduleByScheduleId() {
      //   this.$API
      //     .get(this.$TutorScheduleTodayByScheduleId + 
      //     "?userId=" + 
      //     this.user.id +
      //     "&scheduleId=" +
      //     this.$route.query.scheduleId, {
      //       withCredentials: true,
      //     })
      //     .then((response) => {
      //       if (response.status == 200 && response.data != null) {           
      //         this.schedulebyid = response.data;

      //         // for (let index = 0; index < this.schedulebyid.student.length; index++) {
      //         //   var element = this.schedulebyid.student[index];
      //         //   console.log("TEST", element);

      //         //   //var test = "";
      //         //   if(element.isAttend == false) {
      //         //     var test = true;
      //         //     this.testing = test;
      //         //     console.log("try", this.testing);
      //         //   }
                
      //         // }
      //         console.log("scheduleid", this.schedulebyid);
      //       }
            
      //     });
      // },    

      GetTutorScheduleToday() {
        this.$API
          .get(this.$TutorScheduleToday + "?userId=" + this.user.id, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              this.schedule = response.data;

              for (let index = 0; index < this.schedule.length; index++) {
                var element = this.schedule[index];
                console.log("testsche", element);


                
              }
            }
          });
      },
  
      

      GoToTutorProfile(id , userteacherId) {
        this.schedid = id;
        this.userTeacherId = userteacherId;
        
        this.$router.push(
          "/Class/ClassTutorProfile?scheduleId=" + 
          this.schedid +
          "&userTeacherId=" + 
          this.userTeacherId
        );
      },

      clickYes(studId, scheId) {
        this.studID = studId;

        const formData = new FormData();

        // var studentId = studId;
        // var scheduleId = scheId; 

        formData.append("userId", this.user.id);
        formData.append("studentId", studId);
        formData.append("scheduleId", scheId);
        formData.append("isAttend", true);

        return this.$API
        .post(this.$NewStudentAttending, formData, {
          withCredentials: true
        })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            if (response.data == true) {
              this.parentPay(studId, scheId);
                
            }
            this.GetTutorScheduleToday(this.user.id);
            // this.attendance = true;
            // this.attendanceYes = true;
            // this.attendanceNo = false;
          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
          }
        }); 
      },

      clickRollback(studId, scheId) {
        this.studID = studId;

        const formData = new FormData();


        formData.append("studentId", studId);
        formData.append("scheduleId", scheId);

        return this.$API
        .post(this.$UpdateRollbackAttendance, formData, {
          withCredentials: true
        })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            if (response.data == true) {
              this.GetTutorScheduleToday(this.user.id);
                
            }
          
          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
          }
        }); 
      },

      parentPay(studId, scheId) {
        // this.attendance = true;

        const formData = new FormData();

        // var studentId = studId;
        // var scheduleId = scheId; 

        // formData.append("userId", this.user.id);
        formData.append("studentID", studId);
        formData.append("scheduleId", scheId);

        return this.$API
        .post(this.$ParentPayByStudentID, formData, {
          withCredentials: true
        })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            // if (response.data == true) {
            //   this.parentPay();
            // }
            // this.attendanceYes = true;
          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
          }
        }); 
      },

      clickNo(studId, scheId) {
        this.studID = studId;

        const formData = new FormData();

        // var studentId = studId;
        // var scheduleId = scheId; 

        formData.append("userId", this.user.id);
        formData.append("studentId", studId);
        formData.append("scheduleId", scheId);
        formData.append("isAttend", false);

        return this.$API
        .post(this.$NewStudentAttending, formData, {
          withCredentials: true
        })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            // if (response.data == true) {
            //   this.parentPay(studId, scheId);
                
            // }
            this.GetTutorScheduleToday(this.user.id);
            // this.attendance = true;
            // this.attendanceYes = true;
            // this.attendanceNo = false;
          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
          }
        }); 
      },

      OpenDetail(ids) {
        this.selschedId = ids;
        console.log("mee", this.selschedId);
        console.log("mi", this.schedule);
        this.DetailClass = true;
      },
  
      GoToAttendance(teacherId , id) {
        this.tutorid = teacherId;
        this.schedid = id;
        this.$router.push(
          "/Class/ClassAttendance?teacherId=" + 
          this.tutorid + 
          "&scheduleId=" + 
          this.schedid
        );
      },
  
      GoToChatTutor(teacherId , id) {
        this.tutorid = teacherId;
        this.schedid = id;
        this.$router.push(
          "/Class/ClassChatTutor?teacherId=" +
          this.tutorid + 
          "&scheduleId=" + 
          this.schedid
        );
      },

      GoBack() {
        this.$router.back();
      },
    }
  }
  </script>
  
  <style scoped>
  @import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
  
  input {
    border-bottom: 2px solid #DBDBDB;
    background: none;
    border-top: none;
    border-left: none;
    border-right: none;
    width: 90%;
  }
  
  input ::placeholder {
    color: #E0E0E0;;
  }
  
  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #E0E0E0;;
  }
  .c-app {
    background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  }
  .custom-bg-color {
    background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
    /* Clickable/Light */
  
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    margin: 0px 20px;
    display: flex;
    justify-content: center;
  }
  body {
    font-family: "Montserrat", sans-serif;
  }
  
  .class-teach-name {
    padding: 4px 1px;
    top: 45px;
    /* height: 40px; */
  
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
  
    /* Pure/White */
  
    color: #FFFFFF;
  
  
    /* Inside auto layout */
  
    /* flex: none;
    order: 0;
    flex-grow: 0; */
  }
  
  .tutor-profile-img {
  margin-left: 15px;
  margin-right: 15px;
  border-radius: 8px;
  }
  
  .tutor-profile-name {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 29px;
  color: #000A2C;
  
  }
  
  .tutor-profile-subject {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  
  color: #000A2C;
  }
  
  .tutor-profile-rating {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 150%;
  /* identical to box height, or 18px */
  
  
  /* Pure/Black */
  
  color: #000000;
  }
  
  </style>

<!-- public int userTeacherId { get; set; }

userTeacherId = us.Id, -->